import { createFileRoute } from "@tanstack/react-router";
import CommunityLayout from "lib/components/builders/communities/CommunityLayout";
import CommunityHomePlans from "lib/components/builders/communities/plans/CommunityHomePlans";
import withAuthentication from "../../../../../components/withAuthentication";

function CommunityPage() {
  return (
    <CommunityLayout currentPage="home_plans">
      <CommunityHomePlans />
    </CommunityLayout>
  );
}

export const Route = createFileRoute("/builders/$builder_id/locations/$location_id/home-plans")({
  component: withAuthentication(CommunityPage, { permissions: ["VIEW_HOME_PLANS"] }),
});
